export const RADIO_COLORS = {
  1: "#aba1da",
  2: "#f0a4af",
  3: "#fbce50",
  4: "#75cc92",
  5: "#53a6db",
  6: "#ef6143",
};
